<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Service Provider Settings">Service Provider Settings</span>
      </div>
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="serviceprovidersettings"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="settings-container">

          <mat-accordion multi="true" displayMode="flat">

            <!-- Section: Sales Tax -->
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">receipt_long</mat-icon>
                  <span i18n="@@Sales Tax">Sales Tax</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionSpSalesTax">
                Manage your Service Provider's nexus states (where you collect sales
                tax) and your reciprocity sets (states that accept another state's
                certificate as evidence) for `other` and `wholesale` exemption types.
                Review and act on pending exemption requests from organizations
                under your Service Provider below.
              </div>

              <mat-card appearance="outlined" class="sp-stx-card" *ngIf="spId != null">
                <mat-card-title i18n="@@Nexus and Reciprocity">Nexus and Reciprocity</mat-card-title>
                <mat-card-content>
                  <div *ngIf="salesTaxConfigLoading" style="display: flex; align-items: center; gap: 8px; padding: 8px 0;">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span i18n="@@Loading data">Loading data</span>
                  </div>

                  <div class="sp-stx-error" *ngIf="salesTaxConfigError">{{salesTaxConfigError}}</div>

                  <ng-container *ngIf="!salesTaxConfigLoading">
                    <h4 i18n="@@Nexus States">Nexus States</h4>
                    <div class="sp-stx-help" i18n="@@helpNexusStates">States where this ServiceProvider collects sales tax. Organizations may request exemptions only for these states; other states are shown as no-nexus to operators.</div>
                    <app-sales-tax-states-matrix
                      [config]="salesTaxConfig"
                      mode="nexus"
                      [(selectedStates)]="stxNexusStates">
                    </app-sales-tax-states-matrix>

                    <h4 i18n="@@Reciprocity for Other">Reciprocity — Other</h4>
                    <div class="sp-stx-help" i18n="@@helpReciprocityOther">States that accept another state's certificate as reciprocal evidence for non-profit / other exemptions. The org-side UI pre-checks these states when an issuing state has been entered.</div>
                    <app-sales-tax-states-matrix
                      [config]="salesTaxConfig"
                      mode="reciprocity"
                      [(selectedStates)]="stxReciprocityOther">
                    </app-sales-tax-states-matrix>

                    <h4 i18n="@@Reciprocity for Wholesale">Reciprocity — Wholesale</h4>
                    <div class="sp-stx-help" i18n="@@helpReciprocityWholesale">States that accept another state's resale certificate as reciprocal evidence for wholesale exemptions.</div>
                    <app-sales-tax-states-matrix
                      [config]="salesTaxConfig"
                      mode="reciprocity"
                      [(selectedStates)]="stxReciprocityWholesale">
                    </app-sales-tax-states-matrix>

                    <div class="sp-stx-actions">
                      <button mat-stroked-button color="primary"
                              [disabled]="salesTaxConfigSaving"
                              (click)="saveSalesTaxConfig()">
                        <span i18n="@@Save Sales Tax Configuration">Save Sales Tax Configuration</span>
                      </button>
                      <mat-spinner *ngIf="salesTaxConfigSaving" diameter="18"></mat-spinner>
                    </div>
                  </ng-container>
                </mat-card-content>
              </mat-card>

              <!-- Review queue + detail (shared with NetworkSettings) -->
              <app-sales-tax-review [serviceProviderId]="spId"></app-sales-tax-review>
            </mat-expansion-panel>

            <!-- Section: Payment Collection (CollectionProvider) -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">payments</mat-icon>
                  <span i18n="@@Payment Collection">Payment Collection</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionSpCollectionProvider">Edit the payment-collection settings for your service provider. The payment settings hold the payment-processor routing values and CardPointe credentials used to charge orders under your service provider.</div>

              <div class="sp-cp-error" *ngIf="spCollectionProviderLoadError">
                <mat-icon>error_outline</mat-icon>
                <span>{{spCollectionProviderLoadError}}</span>
              </div>

              <div class="cp-no-mapping" *ngIf="spId != null && !spCollectionProviderLoadError && spCollectionProviderId == null">
                <mat-icon>warning</mat-icon>
                <span i18n="@@No CollectionProvider is mapped to your ServiceProvider. Contact your network administrator.">No CollectionProvider is mapped to your ServiceProvider. Contact your network administrator.</span>
              </div>

              <app-collection-provider-editor
                *ngIf="spCollectionProviderId != null"
                [providerId]="spCollectionProviderId">
              </app-collection-provider-editor>
            </mat-expansion-panel>

          </mat-accordion>

        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

